export default __webpack_public_path__ + "static/media/Estimates-color.ed7b6f69.svg";